<template>
  <section class="weak-g">
    <slot />
  </section>
</template>

<style scoped>
.weak-g:deep(.t-40px) {
  margin-top: var(--base-40px);
}

.weak-g:deep(.l-40px) {
  margin-left: var(--base-40px);
}

.weak-g:deep(.t-80px) {
  margin-top: var(--base-80px);
}

.weak-g:deep(.l-80px) {
  margin-top: var(--base-80px);
}
</style>
